import cache from './CacheManager'

import {CacheConfigurations} from './types'
import Obj from 'core/utility/object'

let cacheConfigurationList: Partial<CacheConfigurations> = {}

/**
 * Set cache configuration options
 *
 * @param {CacheConfigurations} configurations
 * @returns {void}
 */
export function setCacheConfigurations(configurations: CacheConfigurations): void {
  if (configurations.driver) {
    cache.setDriver(configurations.driver)
  }

  if (configurations.prefix) {
    cache.getDriver().setPrefixKey(configurations.prefix)
  }

  if (configurations.valueParer) {
    cache.getDriver().setValueParser(configurations.valueParer)
  }

  if (configurations.valueConverter) {
    cache.getDriver().setValueConverter(configurations.valueConverter)
  }

  cacheConfigurationList = Obj.merge(cacheConfigurationList, configurations)
}

/**
 * Set cache config option by given key
 *
 * @param {string} key
 * @param {any} value
 * @returns {void}
 */
export function setCacheConfig(key: string, value: any): void {
  return Obj.set(cacheConfigurationList, key, value)
}

/**
 * Get all configurations or get option by key
 *
 * @param {string} key
 * @param {any} defaultValue
 * @returns {any}
 */
export function getCacheConfig(key: keyof CacheConfigurations | string, defaultValue?: any): any {
  return Obj.get(cacheConfigurationList, key, defaultValue)
}
